var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44.1782,
    height: 44.1782,
    rx: 22.0891,
    fill: "#0196B1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11030_29243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5189 13.2612H13.2578V29.656C13.2578 29.9905 13.3907 30.3112 13.6272 30.5478C13.8637 30.7843 14.1845 30.9171 14.5189 30.9171H30.9137V29.656H14.5189V13.2612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9149 17.6753H26.5009V18.9364H28.7646L23.9786 23.7224L21.2735 21.011C21.2149 20.9519 21.1451 20.905 21.0683 20.873C20.9915 20.841 20.909 20.8245 20.8258 20.8245C20.7426 20.8245 20.6601 20.841 20.5833 20.873C20.5065 20.905 20.4367 20.9519 20.3781 21.011L15.7812 25.6141L16.6704 26.5032L20.8258 22.3478L23.5309 25.0592C23.5896 25.1183 23.6593 25.1653 23.7361 25.1973C23.813 25.2293 23.8954 25.2458 23.9786 25.2458C24.0619 25.2458 24.1443 25.2293 24.2211 25.1973C24.298 25.1653 24.3677 25.1183 24.4263 25.0592L29.6537 19.8255V22.0893H30.9149V17.6753Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11030_29243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.1782,
    height: 20.1782,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataAnalytics);
export default __webpack_public_path__ + "static/media/dataAnalytics.c932f25b80e9a0e7434a4ea45f967919.svg";
export { ForwardRef as ReactComponent };